import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    padding: 15,
    marginBottom: 30
  },
  inputsSkeleton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  inputsContainerSkeleton: {
    display: 'grid',
    gridTemplateColumns: ' 2fr 1fr',
    gap: '40px',
    width: '100%',
    alignItems: 'flex-start',
    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '5fr 2fr',
      gap: '50px'
    },
    [theme.breakpoints.up(2200)]: {
      gridTemplateColumns: '5fr 3fr',
      gap: '40px'
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  inputSection: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '11px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  skeleton: {
    width: '100%',
    height: 66
  },
  skeletonSwitch: {
    height: 40,
    marginTop: 26
  },
  typographySkeleton: {
    width: '40%',
    height: '84px',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '89px'
    }
  },
  typographySkeletonSwitch: {
    width: '51%',
    [theme.breakpoints.down('md')]: {
      width: '24%'
    },
    [theme.breakpoints.up(1440)]: {
      width: '39%'
    }
  },
  typographySkeletonButton: {
    width: '33%',
    marginRight: '10px',
    [theme.breakpoints.down('md')]: {
      width: '15%'
    },
    [theme.breakpoints.up(1440)]: {
      width: '26%'
    }
  },
  inputProviderNameSkeleton: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    marginBottom: '16px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '0px',
      gap: '0px'
    }
  },
  inputProviderPullSkeleton: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '0px',
      gap: '0px'
    }
  },
  switchAndButtonSkeleton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    },
    [theme.breakpoints.down(400)]: {
      alignItems: 'flex-end',
      flexDirection: 'column'
    }
  }
}))

export default useStyles
